import { useState } from "react";
import HeaderHome from "../components/HeaderHome";
import SiteFooter from "../components/SiteFooter";
import WhatsAppIcon from "../components/WhatsAppIcon";

import imgCurd from "../assets/images/curd.png";

// ✅ Preparation Images
import imgFarm from "../assets/images/milkfromfarm.png";
import imgBoil from "../assets/images/milkboiling.png";
import imgFerment from "../assets/images/fermentation.png";
import imgPack from "../assets/images/packing.png";

const PHONE = "918688307782";

const daysList = [
  "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
];

function ProductCard({ name, price }) {
  const [quantity, setQuantity] = useState(1);
  const [deliveryType, setDeliveryType] = useState("Daily");
  const [selectedDays, setSelectedDays] = useState([]);

  const increase = () => setQuantity((q) => q + 1);
  const decrease = () => setQuantity((q) => (q > 1 ? q - 1 : 1));

  const toggleDay = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day)
        ? prev.filter((d) => d !== day)
        : [...prev, day]
    );
  };

  const handleOrder = () => {
    if (
      (deliveryType === "Weekly" || deliveryType === "Alternate Days") &&
      selectedDays.length === 0
    ) {
      alert("Please select at least one delivery day");
      return;
    }

    const message = `Hi 👋

I want to order:

Product: ${name}
Quantity: ${quantity}

Delivery Type: ${deliveryType}

${
  selectedDays.length > 0
    ? `Selected Days: ${selectedDays.join(", ")}`
    : ""
}

Address:

Please confirm availability.`;

    const url = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="product-card">

      <div className="product-img">
        <img src={imgCurd} alt="Fresh claypot curd" />
      </div>

      <h3>{name}</h3>
      <p className="price">{price}</p>

      <div className="qty-box">
        <button onClick={decrease}>-</button>
        <span>{quantity}</span>
        <button onClick={increase}>+</button>
      </div>

      <select
        value={deliveryType}
        onChange={(e) => setDeliveryType(e.target.value)}
        className="input"
      >
        <option>Daily</option>
        <option>One-time</option>
        <option>Alternate Days</option>
        <option>Weekly</option>
      </select>

      {(deliveryType === "Weekly" || deliveryType === "Alternate Days") && (
        <div className="days-grid">
          {daysList.map((day) => (
            <label key={day} className="day-item">
              <input
                type="checkbox"
                checked={selectedDays.includes(day)}
                onChange={() => toggleDay(day)}
              />
              {day}
            </label>
          ))}
        </div>
      )}

      <button className="btn btn--whatsapp btn-wa" onClick={handleOrder}>
        <WhatsAppIcon className="icon-wa" />
        Order {name}
      </button>
    </div>
  );
}


export default function HomePage() {
  return (
    <div className="site-root">
      <HeaderHome />

      <main>

        {/* ✅ HERO */}
        <section className="hero">
          <div className="container">
            <h1>Fresh Cow Curd in Traditional Clay Pots</h1>

            <p className="tagline">— Thick • Natural • Homemade —</p>

            <p className="lead">
              Made from farm-fresh cow milk and set in eco-friendly clay pots for rich and natural flavor.
            </p>
          </div>
        </section>

        {/* 🥛 PRODUCTS */}
        <section className="products-section">
          <div className="container">
            <h2>Our Products</h2>

            <div className="products-grid">
              <ProductCard name="400ml Curd" price="₹60" />
              <ProductCard name="800ml Curd" price="₹100" />
            </div>
          </div>
        </section>

        {/* 🧑‍🌾 PREPARATION */}
        <section className="prep-section">
          <div className="container">
            <h2>From Farm to Your Table</h2>

            <div className="prep-grid">

              <div className="prep-card">
                <img src={imgFarm} alt="Milk from farm" />
                <h4>1. Fresh Milk</h4>
                <p>Collected directly from healthy cows at local farms.</p>
              </div>

              <div className="prep-card">
                <img src={imgBoil} alt="Boiling milk" />
                <h4>2. Boiling</h4>
                <p>Milk is boiled carefully to ensure purity and safety.</p>
              </div>

              <div className="prep-card">
                <img src={imgFerment} alt="Fermentation" />
                <h4>3. Fermentation</h4>
                <p>Set in natural clay pots for thick and rich curd.</p>
              </div>

              <div className="prep-card">
                <img src={imgPack} alt="Packing" />
                <h4>4. Ready & Packed</h4>
                <p>Freshly packed and delivered to your home.</p>
              </div>

            </div>
          </div>
        </section>

        {/* ⭐ WHY CHOOSE US */}
        <section className="why-section">
          <div className="container">
            <h2>Why Choose Us</h2>

            <div className="why-grid">
              <div>🌿 100% Natural & No Chemicals</div>
              <div>🐄 Farm Fresh Cow Milk</div>
              <div>🏺 Traditional Clay Pot Method</div>
              <div>🚚 Flexible Delivery Options</div>
              <div>📅 Daily / Alternate / Weekly Delivery</div>
              <div>💯 Thick & Authentic Taste</div>
            </div>
          </div>
        </section>

        {/* 📍 DELIVERY AREAS */}
        <section className="delivery-section">
          <div className="container">
            <h2>Delivery Areas</h2>

            <p>
              We currently deliver in:
            </p>

            <ul className="delivery-list">
              <li>Kapra</li>
              <li>ECIL</li>
              <li>Sainikpuri</li>
              <li>AS Rao Nagar</li>
              <li>Dr A S Rao Nagar</li>
              <li>Nearby Areas</li>
            </ul>

            <p>📞 Contact us on WhatsApp for availability in your location.</p>
          </div>
        </section>

      </main>

      <SiteFooter />
    </div>
  );
}